module.exports = __webpack_public_path__ + "img/agriculture.2db6d2fe.jpg";